export default __webpack_public_path__ + "static/media/naqel.ea2d4d9e.svg";